import { APK, LATEST_URL } from "@/data/installApp";
import { logWarn } from "@/lib/log";

const CODE_KEY = "apk_installed_code";
const STORE_KEY = "apk_store"; // "play" when this install came from Google Play (AAB start URL carries &store=play)
const DISMISS_KEY = "apk_update_dismissed";
const TWA_REFERRER = `android-app://${APK.packageId}`;
// Launched from the installed Android app (TWA) — never true for a plain browser tab visiting the same URL.
const launchedFromApp = () => document.referrer.startsWith("android-app://") || !!window.matchMedia?.("(display-mode: standalone)")?.matches;
const plainBrowserTab = () => !document.referrer.startsWith("android-app://") && !!window.matchMedia?.("(display-mode: browser)")?.matches;

// Runs once at startup: the TWA launches "/?apkv=<versionCode>"; legacy 1.0.0 builds only reveal themselves via the referrer.
export function detectApk() {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = parseInt(params.get("apkv"), 10);
    if (code > 0) {
      localStorage.setItem(CODE_KEY, String(code));
      // Google Play mode only inside the real Play build; the sideload APK (no store flag) clears it.
      if (params.get("store") === "play" && launchedFromApp()) localStorage.setItem(STORE_KEY, "play");
      else localStorage.removeItem(STORE_KEY);
      params.delete("apkv");
      params.delete("store");
      const q = params.toString();
      window.history.replaceState(null, "", `${window.location.pathname}${q ? `?${q}` : ""}${window.location.hash}`);
    } else if (document.referrer.startsWith(TWA_REFERRER) && !localStorage.getItem(CODE_KEY)) {
      localStorage.setItem(CODE_KEY, "1");
    } else if (localStorage.getItem(STORE_KEY) && plainBrowserTab()) {
      localStorage.removeItem(STORE_KEY); // a browser tab that once opened a Play-mode URL must not stay in Play mode
    }
  } catch (e) { logWarn("detectApk failed:", e); }
}

export const installedApkCode = () => parseInt(localStorage.getItem(CODE_KEY), 10) || null;
// Google Play build: donations/APK downloads are hidden (Play Billing & distribution policies).
export const isPlayStoreApp = () => localStorage.getItem(STORE_KEY) === "play";
export const dismissedUpdateCode = () => parseInt(localStorage.getItem(DISMISS_KEY), 10) || 0;
export const dismissUpdate = (code) => localStorage.setItem(DISMISS_KEY, String(code));

let latestPromise = null;
// Always straight from the network (service worker bypasses /downloads/); falls back to the bundled constants.
export function fetchLatestApk() {
  if (!latestPromise) {
    latestPromise = fetch(LATEST_URL, { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then((j) => ({ ...APK, ...j }))
      .catch((e) => { logWarn("latest.json unavailable:", e); latestPromise = null; return APK; });
  }
  return latestPromise;
}
